
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.42 8.196l.618.774 3.405 4.798-.464.232s-.078 0-.155-.077-3.018-4.256-3.018-4.256l-.077-.774-.465-.62H8.11c-.233 0-.465-.154-.465-.386l-.928.155-5.881.541-.078-.541s0-.078.155-.078 5.185-.541 5.185-.541l.696.31.774-.078c.077-.232.232-.387.464-.387h.155l.31-.929L10.972 1l.464.232s.077.078 0 .155c-.077.155-2.167 4.72-2.167 4.72l-.619.464-.387.697a.591.591 0 01.155.387c.155.31.077.464 0 .541z"}})])
          )
        }
      }
    